import { render } from "./common-rule.vue?vue&type=template&id=5e64108a"
import script from "./common-rule.vue?vue&type=script&lang=js"
export * from "./common-rule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/common-rule.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e64108a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e64108a', __exports__)) {
    api.reload('5e64108a', __exports__)
  }
  
  module.hot.accept("./common-rule.vue?vue&type=template&id=5e64108a", () => {
    api.rerender('5e64108a', render)
  })

}


export default __exports__